export class DBServerRecord {
    'serverId';
    'serverName';
    'engineType';
    'databases';
    'resource';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "serverId",
            "baseName": "serverId",
            "type": "string",
            "format": ""
        },
        {
            "name": "serverName",
            "baseName": "serverName",
            "type": "string",
            "format": ""
        },
        {
            "name": "engineType",
            "baseName": "engineType",
            "type": "string",
            "format": ""
        },
        {
            "name": "databases",
            "baseName": "databases",
            "type": "Array<DatabaseRecord>",
            "format": ""
        },
        {
            "name": "resource",
            "baseName": "resource",
            "type": "DBResourceMetadata",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DBServerRecord.attributeTypeMap;
    }
    constructor() {
    }
}
